export default __webpack_public_path__ + "static/media/logo.68e8a239.jpg";